import { render, staticRenderFns } from "./PopulationReport.vue?vue&type=template&id=45ff76c2&scoped=true&"
import script from "./PopulationReport.vue?vue&type=script&lang=js&"
export * from "./PopulationReport.vue?vue&type=script&lang=js&"
import style0 from "./PopulationReport.vue?vue&type=style&index=0&id=45ff76c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff76c2",
  null
  
)

export default component.exports